import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Loader, Icon, Input, Modal, Popup, Dropdown} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {getDeepCopyOfBidimensionalArray, checkOrder} from '../utils';
import {orderOptions, controlFields, inputFields, dropdownFields, PNC} from '../static/commonStructures';

const DATA_FIELDS = inputFields.concat(dropdownFields);
const FIELDS_TO_DISPLAY = DATA_FIELDS.concat(controlFields);

class AddPartNumberCodeTable extends Component {
  constructor(props) {
    super(props);
    this.renderDropDownFields = this.renderDropDownFields.bind(this);
    this.handleChangeValue = this.handleChangeValue.bind(this);
  }

  checkPncDuplication(fieldValue, columnName = PNC) {
    const {tableValues} = this.props;

    if (columnName === PNC) {
      if (tableValues.length !== 0) {
        const pncList = tableValues.map((values) => values[0]);
        return pncList.filter((pnc) => pnc === fieldValue).length > 1;
      }
    }
    return false;
  }

  checkPncInDatabase(fieldValue, columnDetail, pncRepeatedInDatabase) {
    if (columnDetail.name === PNC) {
      return pncRepeatedInDatabase.has(fieldValue);
    }
    return false;
  }

  getPncRepeatedSet(fieldValue, columnName = PNC) {
    if (columnName === PNC) {
      this.props.getPncByCode(fieldValue || '__');
    }
  }

  handleOnBlur(fieldValue, columnName = PNC) {
    this.getPncRepeatedSet(fieldValue, columnName);
  }

  handleChangeValue(event, position, data = null) {
    const {rowIndex, columnIndex} = position;
    const {tableValues} = this.props;
    const updatedTableValues = getDeepCopyOfBidimensionalArray(tableValues);
    const updatedData = data ? data.value : event.target.value;
    updatedTableValues[rowIndex][columnIndex] = updatedData.toUpperCase();
    this.props.handleTableValuesState(updatedTableValues);
  }

  renderRedErrorMessage(message) {
    return <div className='invalid-value'>{message}</div>;
  }

  deleteRow(row) {
    const {tableValues} = this.props;

    if (tableValues.length === 1) {
      this.props.handleTableValuesState([]);
      return;
    }
    const updatedTableValues = getDeepCopyOfBidimensionalArray(tableValues);
    updatedTableValues.splice(row, 1);
    this.props.handleTableValuesState(updatedTableValues);
  }

  renderDeleteAction(row) {
    const INDEX_OF_DELETE_CONTROL = 0;
    const deleteWidth = controlFields[INDEX_OF_DELETE_CONTROL].width;
    return (
      <Table.Cell textAlign='center' style={{'width': deleteWidth}}>
        <Modal
          size='mini'
          trigger={
            <span className='link'>
              <Popup
                trigger={
                  <span>
                    <Icon link name='close' color='red' size='large' />
                  </span>
                }
                content='Eliminar'
                position='top center'
                inverted
              />
            </span>
          }
          header='¿Desea eliminar el item seleccionado?'
          actions={[
            {'key': 'cancel', 'content': 'Cancelar'},
            {
              'key': 'done',
              'content': 'Confirmar',
              'positive': true,
              'onClick': this.deleteRow.bind(this, row),
              'primary': true,
            },
          ]}
        />
      </Table.Cell>
    );
  }

  renderDropDownFields(element, rowIndex) {
    return dropdownFields.map((item) => {
      const columnIndex = FIELDS_TO_DISPLAY.findIndex((fieldToDisplay) => {
        return fieldToDisplay.name === item.name;
      });
      const position = {'rowIndex': rowIndex, 'columnIndex': columnIndex};
      return (
        <Table.Cell
          key={`cell${rowIndex.toString().concat(columnIndex)}`}
          style={{'width': item.width}}
        >
          <Dropdown
            key={`selector${rowIndex.toString().concat(columnIndex)}`}
            style={{'width': dropdownFields.width}}
            selection
            upward
            compact
            value={element[columnIndex] || 'S'}
            options={orderOptions}
            onChange={(event, data) =>
              this.handleChangeValue(event, position, data)
            }
          />
          {checkOrder(element[columnIndex]) && (
            <div className='invalid-value'>Seleccione opción</div>
          )}
        </Table.Cell>
      );
    });
  }

  renderDuplicatedPncMessage(duplicatedPnc) {
    if (duplicatedPnc) {
      return this.renderRedErrorMessage('PNC duplicado');
    }
  }

  renderPncAlreadyInDatabase(pncExistsInDatabase) {
    if (pncExistsInDatabase) {
      return this.renderRedErrorMessage('Actualizando PNC');
    }
  }

  renderInputFields(element, rowIndex) {
    const {pncRepeatedInDatabase} = this.props;
    return inputFields.map((columnDetail, columnIndex) => {
      const position = {'rowIndex': rowIndex, 'columnIndex': columnIndex};
      const duplicatedPnc = this.checkPncDuplication(
        element[columnIndex],
        columnDetail.name
      );
      const pncExistsInDatabase = this.checkPncInDatabase(
        element[columnIndex],
        columnDetail,
        pncRepeatedInDatabase
      );
      return (
        <Table.Cell key={columnIndex} style={{'width': columnDetail.width}}>
          <Input
            error={duplicatedPnc}
            maxLength={columnDetail.maxLength}
            required={columnDetail.required}
            style={{'width': columnDetail.width}}
            key={rowIndex.toString().concat(columnIndex)}
            value={element[columnIndex] || ''}
            onChange={(event) => this.handleChangeValue(event, position)}
            onBlur={() =>
              this.handleOnBlur(element[columnIndex], columnDetail.name)
            }
          />
          {this.renderDuplicatedPncMessage(duplicatedPnc)}
          {this.renderPncAlreadyInDatabase(pncExistsInDatabase)}
        </Table.Cell>
      );
    });
  }

  renderPncParsedData() {
    const {tableValues} = this.props;
    if (!tableValues) {
      return null;
    }
    return tableValues.map((element, rowIndex) => {
      const duplicatedPnc = this.checkPncDuplication(element[0]);
      return (
        <Table.Row key={rowIndex} negative={duplicatedPnc}>
          {this.renderInputFields(element, rowIndex)}
          {this.renderDropDownFields(element, rowIndex)}
          {this.renderDeleteAction(rowIndex)}
        </Table.Row>
      );
    });
  }

  renderLoaderOrPncParsedData() {
    const {loading} = this.props;
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%' textAlign='center'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderPncParsedData();
  }

  renderTableHeader() {
    return (
      <Table.Row>
        {FIELDS_TO_DISPLAY.map((element, index) => {
          return (
            <Table.HeaderCell textAlign='center' key={index}>
              {element.name}
            </Table.HeaderCell>
          );
        })}
      </Table.Row>
    );
  }

  render() {
    return (
      <Table striped className='toyota-grid'>
        <Table.Header>{this.renderTableHeader()}</Table.Header>
        <Table.Body>{this.renderLoaderOrPncParsedData()}</Table.Body>
      </Table>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'pncRecord': state.partNumberCodeInstance.record,
    'loading': state.partNumberCodeInstance.loading,
  };
};

const {getPncByCode} = Actions;

export default connect(mapStateToProps, {
  getPncByCode,
})(AddPartNumberCodeTable);
